export default (numberOfHours: number) => {
  if (numberOfHours === 1) {
    return `${numberOfHours} godzina`;
  }

  if (
    numberOfHours % 10 >= 2 &&
    numberOfHours % 10 <= 4 &&
    (numberOfHours % 100 < 10 || numberOfHours % 100 >= 20)
  ) {
    return `${numberOfHours} godziny`;
  }

  return `${numberOfHours} godzin`;
};
